// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateQuestionablePartSearchCriteria = (state, action) => action.partNumber;

const resetQuestionablePartSearchCriteria = () => getDefaultState().partNumberSearchCriteria;

export default (state = getDefaultState().partNumberSearchCriteria, action) => {

    const actionTypes = {
        [actions.UPDATE_QUESTIONABLE_PART_SEARCH_CRITERIA]: updateQuestionablePartSearchCriteria,
        [actions.RESET_QUESTIONABLE_PART_SEARCH_REPORT]: resetQuestionablePartSearchCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/reducers/criteria.js